if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if(this.form.querySelector('[name=id]')){
        this.form.querySelector('[name=id]').disabled = false;
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';

      this.bundleContainer = this.closest('product-info')?.querySelector('.product-upsells');
      this.bundleCheckboxes = this.bundleContainer?.querySelectorAll('input[type="checkbox"]');
      this.originalButtonText = this.submitButton?.querySelector('span')?.textContent || 'Add to cart';
      this.addItemsText = this.submitButton?.dataset.addItemsToBag || 'Add {{count}} items to bag';

      this.productInfo = this.closest('product-info');
      this.quantityInput = this.productInfo?.querySelector('input[name="quantity"]');
      this.totalQuantity = 1;
      this.productTemplate = document.getElementById('template-product');
      
      this.chooseOptionsErrorMessage = this.dataset.chooseOptionsErrorMessage;
    }

    connectedCallback() {
      this.bundleCheckboxes?.forEach(checkbox => {
        checkbox.addEventListener('change', this.updateButtonText.bind(this));
      });

      this.quantityInput?.addEventListener('change', this.handleQuantityChange.bind(this));
      this.quantityInput?.addEventListener('input', this.handleQuantityChange.bind(this));

      this.form.addEventListener('change', () => {
        if (!this.optionNotSelected()) {
          this.handleErrorMessage(false);
        }
      });

      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        this.handleErrorMessage(false);

        if (this.productTemplate) {
          this.resetButtonState();
        } else {
          this.updateButtonText();
        }
      });
    }

    handleQuantityChange(event) {
      this.totalQuantity = Number(event.target.value);;
      this.updateButtonText();
    }

    resetButtonState() {
      this.totalQuantity = 1;
      this.updateButtonText();
    }

    updateButtonText() {
      if (!this.submitButton) return;
    
      const checkedCount = this.bundleCheckboxes ?
        Array.from(this.bundleCheckboxes).filter(checkbox => checkbox.checked).length : 0;

      const totalItemsCount = checkedCount + this.totalQuantity;

      const buttonTextSpan = this.submitButton.querySelector('span');

      if (!buttonTextSpan) return;

      if (totalItemsCount > 1) {
        const newText = this.addItemsText.replace('{{count}}', totalItemsCount);
        buttonTextSpan.textContent = newText;
      } else {
        buttonTextSpan.textContent = this.originalButtonText;
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      const unselectedOption = this.optionNotSelected();
      if (unselectedOption) {
        const errorMessage = this.chooseOptionsErrorMessage.replace('option', unselectedOption.toLowerCase());
        this.handleErrorMessage(errorMessage);
        return;
      }

      this.handleErrorMessage(false);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['Content-Type'] = 'application/json';

      const formData = {};

      if (this.cart) {
        formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
        formData.sections_url = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }

      const items = [];
      const productInfo = this.closest('product-info');
      const formId = this.form.id;
      const bundleCheckedProducts = productInfo?.querySelectorAll('.product-upsells input:checked');

      const indexedIdInputs = this.form.querySelectorAll('input[name^="items["][name$="[id]"]');
      const quantityInput = productInfo?.querySelector('input[name="quantity"]');

      if (indexedIdInputs.length) {
        indexedIdInputs.forEach((input, index) => {
          const quantityField = this.form.querySelector(`input[name="items[${index}][quantity]"]`);
          const barcodeField = this.form.querySelector(`input[name="items[${index}][properties][_barcode]"]`);

          items.push({
            id: input.value,
            quantity: index === 0 ? Number(quantityInput?.value ?? quantityField?.value ?? 1) : Number(quantityField?.value ?? 1),
            properties: {
              ...((barcodeField != null) && {
                _barcode: barcodeField.value,
              }),
            },
          });
        });
      } else {
        const mainProduct = this.form.querySelector('input[name="id"]');
        const barcode = this.form.querySelector('input[name="properties[_barcode]"]') || productInfo?.querySelector('input[name="properties[_barcode]"]');

        if (!mainProduct) return;

        items.push({
          id: mainProduct.value,
          quantity: Number(quantityInput?.value ?? 1),
          properties: {
            ...((barcode != null) && {
              _barcode: barcode.value,
            }),
          },
        });
      }

      const productGroups = this.closest('.product')?.querySelectorAll('product-group');

      productGroups?.forEach((productGroup) => {
        const productGroupCurrent = productGroup.dataset.selectedType;

        if (!productGroupCurrent || !productGroupCurrent.includes(':')) return;

        const separatorIndex = productGroupCurrent.indexOf(':');
        const rawType = productGroupCurrent.slice(0, separatorIndex).trim();
        const productGroupData = productGroupCurrent.slice(separatorIndex + 1).trim();

        if (!rawType || !productGroupData || !items[0]) return;

        const normalizedType = rawType.toLowerCase();
        let productGroupType = rawType;

        if (normalizedType === 'color' || normalizedType === 'colour') {
          productGroupType = 'Colour';
        } else if (normalizedType === 'size') {
          productGroupType = 'Size';
        }

        items[0].properties = items[0].properties || {};
        items[0].properties[productGroupType] = productGroupData;
      });

      bundleCheckedProducts?.forEach((product) => {
        items.push({
          id: product.value,
          quantity: 1,
        });
      });

      formData.items = items;

      config.body = JSON.stringify(formData);

      fetch(routes.cart_add_url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formId, errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formId });

          this.error = false;

          const quickAddModal = this.closest('quickbuy-drawer') || this.closest('hotspot-drawer');

          if (quickAddModal) {
            document.body.addEventListener('drawerClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });

            quickAddModal.close(true);
          } else {
            this.cart.renderContents(response);
          }

          this.resetButtonState();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    optionNotSelected() {
      const modalRoot = this.closest('three-sixty-modal');
      const productInfo = this.closest('product-info');
      const scopeRoot = modalRoot || productInfo;
      if (!scopeRoot) return null;

      const optionsContainer = scopeRoot.querySelector('variant-radios');
      if (!optionsContainer) return null;

      const fieldsets = optionsContainer.querySelectorAll('fieldset');
      for (const fieldset of fieldsets) {
        const dropdownLabel = fieldset.querySelector('variants-dropdown .select__label');
        if (dropdownLabel) {
          if (dropdownLabel.classList.contains('select__label--placeholder')) {
            const legend = fieldset.querySelector('legend');
            if (legend) {
              return legend.textContent.trim();
            }
            return 'option';
          }

          continue;
        }

        const selected = fieldset.querySelector('input[type="radio"]:checked');
        if (!selected) {
          const legend = fieldset.querySelector('legend');
          if (legend) {
            return legend.textContent.trim();
          }
        }
      }

      return null;
    }

    handleErrorMessage(errorMessage = false, validateOptionSelection = false) {
      if (this.hideErrors) return;

      if (validateOptionSelection) {
        const unselectedOption = this.optionNotSelected();
        if (unselectedOption) {
          errorMessage = this.chooseOptionsErrorMessage.replace('option', unselectedOption.toLowerCase());
        }
      }

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

      if (!this.errorMessageWrapper) return;

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }
  });
}
